import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useFlag, useFlagsActions } from "@innovid/feature-flags-react";
import { FEATURE_FLAGS } from "featureFlag/featureFlag";
import { isPredictiveScoringEnabled, getAdvertiserId } from "selectors/PredictiveScoring";

export function usePredictiveScoringEnabled() {
	const { updateContext } = useFlagsActions();
	const advertiserId = useSelector(getAdvertiserId);

	// Predictive scoring is rolled out per advertiser. By default the GrowthBook context is loaded
	// from the auth token (the user), so evaluate the flag against the advertiser that owns the
	// current library instead. updateContext merges, so this only adds advertiserId and leaves the
	// user attributes other flags rely on untouched.
	useEffect(() => {
		if (advertiserId !== null) {
			updateContext({ advertiserId });
		}
	}, [advertiserId, updateContext]);

	const isGrowthBookEnabled = useFlag(FEATURE_FLAGS.PREDICTIVE_SCORING);
	const isAdvertiserEnabled = useSelector(isPredictiveScoringEnabled);

	return isGrowthBookEnabled && isAdvertiserEnabled;
}
